import axios from "axios";
import { getEncryptedRequest } from './services/rsa-encryption.service';

const instance = axios.create({
    baseURL: process.env.REACT_APP_BASE_API_URL
});

export const quartzInstance = axios.create({
    baseURL: process.env.REACT_APP_BASE_QUARTZ
});

if (window.top !== window.self) {
    try {
        instance.interceptors.request.use(function (config) {
            if (config?.method === "post" && config?.data) {
                config['data'] = getEncryptedRequest(config.data);
                return config;
            }
            return config;
        });

        instance.interceptors.request.use(function (config) {
            return window.shopify.idToken()
                .then((token) => {
                    config.headers["X-Shopify-Access-Token"] = `Bearer ${token}`;
                    return config;
                });
        });

        instance.interceptors.response.use(function (response) {
            return response.data;
        }, function (error) {
            return Promise.reject(error.response.data ? error.response.data : { message: error.response.statusText });
        });

        quartzInstance.interceptors.request.use(function (config) {
            return window.shopify.idToken()
                .then((token) => {
                    config.headers["X-Shopify-Access-Token"] = `Bearer ${token}`;
                    return config;
                });
        });

        quartzInstance.interceptors.response.use(function (response) {
            return response.data;
        }, function (error) {
            return Promise.reject(error.response.data ? error.response.data : { message: error.response.statusText });
        });
    } catch (error) {
    }
}

export default instance;